export default function PreviewBanner() {
  // Only show the staging marker on the *.vercel.app preview aliases.
  // On the live custom domains (daksfirst.com, invest.daksfirst.com) it stays hidden.
  const isStaging =
    typeof window !== "undefined" &&
    window.location.hostname.endsWith(".vercel.app");

  if (!isStaging) return null;

  return (
    <div className="preview-banner">
      STAGING BUILD · not the live site · live at daksfirst.com
    </div>
  );
}
